import { render, staticRenderFns } from "./TeamLineup.vue?vue&type=template&id=0c7be0f1&scoped=true&"
import script from "./TeamLineup.vue?vue&type=script&lang=js&"
export * from "./TeamLineup.vue?vue&type=script&lang=js&"
import style0 from "./TeamLineup.vue?vue&type=style&index=0&id=0c7be0f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7be0f1",
  null
  
)

export default component.exports